import React from "react";
import { MapperListContainer } from "../../../containers";

const MapperList = (props) => {
  return <MapperListContainer {...props} />;
};

export default MapperList;
